import React, { useCallback, useEffect, useState } from 'react';
import '../index.css';
import { useAuth } from '../context/authContext';
import { getOrganisation } from '../services/organisation.service';
import BaseCurrencyCard from '../components/workflows/BaseCurrencyCard';
import TimezoneCard from '../components/settings/TimezoneCard';
import PaymentExpiryCard from '../components/settings/PaymentExpiryCard';
import {
    BaseCurrencyCardSkeleton,
    PaymentExpiryCardSkeleton,
    TimezoneCardSkeleton,
} from '../components/ui/card-skeletons';
import AsyncContent from '../components/ui/AsyncContent';

const OrgSettingsPage = () => {

    const { user } = useAuth();
    const [organisation, setOrganisation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [reload, setReload] = useState(false);

    const triggerReload = useCallback(() => setReload((prev) => !prev), []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const orgRes = await getOrganisation(user.organisationId, user.token);
            if (orgRes && orgRes.status === 200) {
                setOrganisation(orgRes.data.data);
            }
            setLoading(false);
        };

        fetchData();
    }, [user.token, user.organisationId, reload]);

    return (
        <div className="App">
            <div className="max-w-5xl mx-auto flex flex-col gap-8">
                <div>
                    <h2 className="mb-1">Organisation Settings</h2>
                    <p className="text-gray-500">
                        Manage organisation-wide preferences such as base currency, timezone and payment expiry.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                    <AsyncContent loading={loading} skeleton={<BaseCurrencyCardSkeleton />}>
                        <BaseCurrencyCard
                            baseCurrency={organisation?.baseCurrency}
                            convertToBaseCurrency={organisation?.convertToBaseCurrency}
                            tierToleranceType={organisation?.tierToleranceType}
                            tierToleranceValue={organisation?.tierToleranceValue}
                            onUpdated={triggerReload}
                        />
                    </AsyncContent>
                    <AsyncContent loading={loading} skeleton={<TimezoneCardSkeleton />}>
                        <TimezoneCard
                            timezone={organisation?.timezone}
                            onUpdated={triggerReload}
                        />
                    </AsyncContent>
                    <AsyncContent loading={loading} skeleton={<PaymentExpiryCardSkeleton />}>
                        <PaymentExpiryCard
                            paymentExpiryBasis={organisation?.paymentExpiryBasis}
                            paymentExpiryValue={organisation?.paymentExpiryValue}
                            paymentExpiryUnit={organisation?.paymentExpiryUnit}
                            paymentExpiryHours={organisation?.paymentExpiryHours}
                            onUpdated={triggerReload}
                        />
                    </AsyncContent>
                </div>
            </div>
        </div>
    );
};

export default OrgSettingsPage;
